import { Button, Typography } from '@neo4j-ndl/react';
import { PLG_EVENTS } from '@nx/analytics-service';
import { APP_SCOPE } from '@nx/constants';
import { useActiveOrg, useAuraUser, useTrackEvent } from '@nx/state';
import type { ReactNode } from 'react';

import VSCode from '../assets/vscode.svg';

const ToolRow = ({
  title,
  icon,
  buttonText,
  children,
  href,
  onClick,
}: {
  title: string;
  icon: ReactNode;
  buttonText: string;
  children: ReactNode;
  href: string;
  onClick?: () => void;
}) => {
  return (
    <div className="border-neutral-border-weak flex items-center gap-4 border-b pb-3 pt-3" title={title}>
      <div className="flex h-[56px] w-[56px] items-center justify-center p-3">{icon}</div>
      <div className="flex grow flex-col gap-2">
        <h6>{title}</h6>
        <Typography variant="body-medium" className="text-neutral-text-weak tracking-normal">
          {children}
        </Typography>
      </div>
      <Button color="primary" size="small" fill="outlined" as="a" href={href} onClick={onClick}>
        {buttonText}
      </Button>
    </div>
  );
};

const Tools = () => {
  const track = useTrackEvent();
  const { user } = useAuraUser();
  const org = useActiveOrg();
  return (
    <div className="flex flex-col gap-5">
      <ToolRow
        title="Visual Studio Code extension"
        icon={<img src={VSCode} draggable={false} width="32px" height="32px" />}
        buttonText="Install"
        href="vscode:extension/neo4j-extensions.neo4j-for-vscode"
        onClick={() => {
          track({
            event: PLG_EVENTS.DEVELOPER_HUB_LINK,
            scope: APP_SCOPE.aura,
            properties: { link: 'vscode', org_id: org.id, user_id: user?.id },
          });
        }}
      >
        Run Cypher without leaving your IDE with Neo4j VSCode Extension
      </ToolRow>
    </div>
  );
};

export default Tools;
